import { UserNotesService } from '@/backend/market'
import { UserNoteRepository } from '../../domain/repositories/UserNoteRepository'
import { UserNoteModel } from '../models/UserNoteModel'
import type { UserNoteFilterEntity } from '../../domain/entities/UserNoteFilterEntity'
import { UserNoteFilterModel } from '../models/UserNoteFilterModel'
import { UserNoteMiniModel } from '../models/UserNoteMiniModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { UserNoteMiniEntity } from '../../domain/entities/UserNoteMiniEntity'

export class UserNoteRepositoryImpl implements UserNoteRepository {
  async getUserNotes(
    filterData: UserNoteFilterEntity
  ): Promise<PaginateEntity<UserNoteMiniEntity[]> | { error: true }> {
    const userNoteFilterModel = new UserNoteFilterModel(filterData)
    try {
      const response = await UserNotesService.getUserNotesAdmin(userNoteFilterModel)

      const userModels = response.items?.map((item) => new UserNoteMiniModel(item))
      const userNoteResponse = new PaginateEntity<UserNoteMiniModel[]>(response, userModels)

      return userNoteResponse
    } catch {
      return { error: true }
    }
  }
  async getUserNote(id: string): Promise<UserNoteModel | { error: true }> {
    try {
      const response = await UserNotesService.getUserNoteAdmin({ id })
      const userNoteModel = new UserNoteModel(response)
      return userNoteModel
    } catch {
      return { error: true }
    }
  }

  async createUserNote({
    userId,
    note
  }: {
    userId: string
    note: string
  }): Promise<UserNoteModel | { error: true }> {
    try {
      const response = await UserNotesService.postUserNoteAdmin({
        requestBody: { userId, note }
      })
      const userNoteModel = new UserNoteModel(response)
      return userNoteModel
    } catch {
      return { error: true }
    }
  }
  async updateUserNote({
    id,
    note
  }: {
    id: string
    note: string
  }): Promise<UserNoteModel | { error: true }> {
    try {
      const response = await UserNotesService.updateUserNoteAdmin({
        id,
        requestBody: { note }
      })
      const userNoteModel = new UserNoteModel(response)
      return userNoteModel
    } catch {
      return { error: true }
    }
  }
  async deleteUserNote(id: string): Promise<UserNoteModel | { error: true }> {
    try {
      const response = await UserNotesService.deleteUserNoteAdmin({
        id
      })
      const userNoteModel = new UserNoteModel(response)
      return userNoteModel
    } catch {
      return { error: true }
    }
  }
}
